import { Header } from '@almbrand/header';
import { useDesignSystemThemeName } from 'hooks/useDesignSystemThemeName';
import { NavLink } from 'react-router-dom';

export const HeaderComponent: React.FC<HeaderReference> = ({
	logoImage,
	logoUrl,
	headerLinks,
	loginUrl,
	loginLabelText,
	//	menuMobilIcon,
	//	menuCloseMobilIcon,
	personalizedLinks,
}) => {
	const rootUrl = window.location.origin;
	const themeName = useDesignSystemThemeName();

	const mapHeaderLinks = (links: any[]) => {
		return links
			.map((link) => ({
				text: link?.text ?? '',
				title: link?.title ?? '',
				url: link?.url ?? '',
				target: link?.target ?? '',
				isExternalLink: link?.isExternalLink ?? false,
				useVueRoute: link?.useVueRoute ?? false,
				trackEvent: JSON.stringify({
					event: 'trackNavigation',
					navigationAction: link?.text ?? '',
					navigationDestination: `${rootUrl}${link?.url ?? ''}`,
					navigationType: 'primary navigation',
				}),
			}))
			.filter((link) => link.text && link.url);
	};

	const segmentedHeaderLinks = personalizedLinks?.items?.map((item) => ({
		text: item.content.urlLabel ?? '',
		url: item.content.url?.url ?? '',
		title: item.content.urlLabel ?? '',
		target: '_blank',
		isExternalLink: false,
		useVueRoute: false,
		trackEvent: JSON.stringify({
			event: 'trackNavigation',
			navigationAction: item.content.urlLabel ?? '',
			navigationDestination: item.content.url?.url ?? '',
			navigationType: 'segment navigation',
		}),
	}));

	return (
		<Header
			logoProps={{
				logoUrl: logoImage?.url ?? '',
				link: logoUrl?.url ?? '',
			}}
			navigationLinks={mapHeaderLinks(headerLinks)}
			segmentLinks={segmentedHeaderLinks}
			buttonProps={{
				buttonType: 'personal',
				children: loginLabelText,
				size: 'small',
				linkButtonSettings: {
					href: loginUrl?.url,
				},
				iconProps: {
					themeName,
					icon: 'lock',
					width: '36',
					height: '36',
				},
			}}
			renderChildren={(link: Link): JSX.Element => {
				return (
					<NavLink
						key={link.url}
						to={link.url}
						title={link.title}
						target={link.target}
						data-track-event={link.trackEvent}
					>
						{link.text}
					</NavLink>
				);
			}}
		/>
	);
};
